import React from "react";
import { Route, Switch } from "react-router-dom";

import asyncComponent from "util/asyncComponent";

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route path={`${match.url}support`} component={asyncComponent(() => import('./Support'))} />
      <Route path={`${match.url}admin`} component={asyncComponent(() => import('./Admin'))} />
      <Route path={`${match.url}found`} component={asyncComponent(() => import('./Found'))} />
      <Route path={`${match.url}etcAdvertising`} component={asyncComponent(() => import('./EtcAdvertising'))} />
      <Route path="/missing/:id?" component={asyncComponent(() => import('./Missing'))} />
      <Route path={`${match.url}samplePage`} component={asyncComponent(() => import('./SamplePage'))} />
    </Switch>
  </div>
);

export default App;
